export const formatPersonalNumber = (value: string): string => {
  let filtered = value.replace(/[^0-9-]/g, '')
  const digitCount = filtered.replace(/-/g, '').length

  // Limit to 12 digits maximum
  if (digitCount > 12) {
    const digits = filtered.replace(/-/g, '').slice(0, 12)

    // Preserve dash position if it exists
    filtered = filtered.includes('-')
      ? `${digits.slice(0, filtered.indexOf('-'))}-${digits.slice(filtered.indexOf('-'))}`
      : digits
  }

  // Ensure only one dash is used
  if (filtered.includes('-')) {
    const [firstPart, ...rest] = filtered.split('-')
    filtered = `${firstPart}-${rest.join('')}`
  }

  return filtered
}

export const toDisplayPersonalNumber = (value: string): string => value.replace(/^(\d{8})(\d{4})$/, '$1-$2')
